import React from "react"
import SearchOffIcon from "@mui/icons-material/SearchOff"
import { COLORS } from "../utils"

/**
 * Reusable Empty State component for search results
 * 
 * @param {string} title - Main title text
 * @param {string} subtitle - Subtitle/description text
 * @param {React.ReactNode} icon - Optional custom icon (defaults to SearchOffIcon)
 * @param {object} sx - Optional additional styles for the container
 */
const EmptySearchState = ({
  title,
  subtitle,
  icon,
  sx = {},
}) => {
  return (
    <div style={{ ...styles.container, ...sx }}>
      <div style={styles.icon}>
        {icon || <SearchOffIcon sx={{ fontSize: "32px" }} />}
      </div>
      <div style={styles.title}>{title}</div>
      {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
    </div>
  )
}

export default EmptySearchState

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "40px 16px",
  },
  icon: {
    fontSize: "32px",
    height: "32px",
    marginBottom: "12px",
    color: COLORS.BLACK_600,
  },
  title: {
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
    color: COLORS.BLACK800,
    marginBottom: "16px",
  },
  subtitle: {
    fontSize: "14px",
    lineHeight: "22px",
    color: COLORS.BLACK_600,
  },
}
